var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vuestic-page-not-found-sad-wallpaper" }, [
      _c("img", {
        staticClass: "vuestic-page-not-found-sad-wallpaper__sad-image",
        attrs: { src: "https://i.imgur.com/hu80UGU.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }